module.exports = __webpack_public_path__ + "img/iptu-maio.eaee9713.jpeg";